import {
  FileItem
} from "./chunk-PJOL3MPD.mjs";

// src/views/Files/FilesList/FilesList.tsx
import { Flex } from "@chakra-ui/react";
import { jsx } from "react/jsx-runtime";
var FilesList = ({ files, onDelete }) => /* @__PURE__ */ jsx(Flex, {
  direction: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: 1,
  w: "100%",
  children: files.map((file) => /* @__PURE__ */ jsx(FileItem, {
    file,
    onDelete
  }, `${file.name}-${file.lastModified}`))
});

export {
  FilesList
};
